import { render, staticRenderFns } from "./CmgRecentAndFavoriteOrders.vue?vue&type=template&id=cd389c00&scoped=true&lang=pug"
import script from "./cmg-recent-and-favorite-orders.ts?vue&type=script&lang=ts&external"
export * from "./cmg-recent-and-favorite-orders.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRecentAndFavoriteOrders.vue?vue&type=style&index=0&id=cd389c00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd389c00",
  null
  
)

export default component.exports